/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Equipment_EmptyInputs */

const en_us2_profile_editors_equipment_empty = /** @type {(inputs: Profile_Editors_Equipment_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick at least one item.`)
};

const pt_br2_profile_editors_equipment_empty = /** @type {(inputs: Profile_Editors_Equipment_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque pelo menos um item.`)
};

const es_419_profile_editors_equipment_empty = /** @type {(inputs: Profile_Editors_Equipment_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca al menos un elemento.`)
};

const pt_pt2_profile_editors_equipment_empty = /** @type {(inputs: Profile_Editors_Equipment_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca pelo menos um item.`)
};

const fr_fr2_profile_editors_equipment_empty = /** @type {(inputs: Profile_Editors_Equipment_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coche au moins un élément.`)
};

const de_de2_profile_editors_equipment_empty = /** @type {(inputs: Profile_Editors_Equipment_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl mindestens ein Teil aus.`)
};

const it_it2_profile_editors_equipment_empty = /** @type {(inputs: Profile_Editors_Equipment_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona almeno un elemento.`)
};

/**
* | output |
* | --- |
* | "Tick at least one item." |
*
* @param {Profile_Editors_Equipment_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_equipment_empty = /** @type {((inputs?: Profile_Editors_Equipment_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Equipment_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_equipment_empty(inputs)
	if (locale === "es-419") return es_419_profile_editors_equipment_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_equipment_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_equipment_empty(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_equipment_empty(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_equipment_empty(inputs)
	return en_us2_profile_editors_equipment_empty(inputs)
});
export { profile_editors_equipment_empty as "profile-editors.equipment_empty" }